import { useMemo } from 'react';

import { getBuildInfo } from '../utils/buildInfo';
import { toast } from './toast/useToast';

type BuildInfoBadgePlacement = 'fixed' | 'absolute' | 'inline';

type BuildInfoBadgeProps = {
  placement?: BuildInfoBadgePlacement;
  className?: string;
};

const BuildInfoBadge = ({ placement = 'fixed', className }: BuildInfoBadgeProps) => {
  const info = useMemo(() => getBuildInfo(), []);

  const text = `build ${info.shaShort}`;

  const baseButtonClassName =
    'm-0 cursor-pointer select-none rounded-full bg-black/50 px-2 py-1 font-mono text-[11px] leading-none text-white/30 shadow-lg backdrop-blur hover:text-white/50';

  const positionedButtonClassName =
    placement === 'fixed'
      ? 'fixed bottom-0 left-0 z-[9999]'
      : placement === 'absolute'
        ? 'absolute bottom-0 left-0 z-[9999]'
        : '';

  const handleCopyClick = async () => {
    await navigator.clipboard.writeText(text);
    toast({
      title: 'Build Info Copied',
      description: text,
      variant: 'success',
    });
  };

  const button = (
    <button
      type="button"
      onClick={handleCopyClick}
      aria-label="Copy Build Info"
      title="Copy Build Info"
      className={[baseButtonClassName, positionedButtonClassName, className].filter(Boolean).join(' ')}
    >
      {text}
    </button>
  );

  if (placement === 'inline') {
    return <div className="relative inline-flex items-center">{button}</div>;
  }

  return button;
};

export default BuildInfoBadge;
